import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Chip,
  IconButton,
} from '@mui/material';
import { Business, VerifiedUser, ArrowBack } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { CompanyInfo } from '../../entities/InvoicePortal';

interface SimpleNavbarProps {
  companyInfo: CompanyInfo;
}

export const SimpleNavbar: React.FC<SimpleNavbarProps> = ({ companyInfo }) => {
  const theme = useTheme();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.05)',
        color: 'text.primary',
        mb: 0,
        mx: 0,
      }}
    >
      <Toolbar sx={{ py: 1, px: { xs: 2, sm: 3 }, minHeight: '64px' }}>
        {/* Logo/Avatar de la empresa - estilo Apple */}
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            bgcolor: 'text.primary',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 3,
          }}
        >
          <Business sx={{ color: 'white', fontSize: 20 }} />
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              fontSize: '1.1rem',
              letterSpacing: '-0.02em', // Tracking más apretado estilo Apple
            }}
          >
            {companyInfo.legal_name}
          </Typography>
        </Box>

        <Chip
          icon={<VerifiedUser sx={{ fontSize: 14 }} />}
          label="Verificado"
          size="small"
          sx={{
            fontSize: '0.75rem',
            height: 28,
            bgcolor: 'success.main',
            color: 'white',
            fontWeight: 600,
            '& .MuiChip-icon': {
              color: 'white',
            },
          }}
        />
      </Toolbar>
    </AppBar>
  );
};
